module.exports = __webpack_public_path__ + "img/10.61b395e6.jpg";